/* import __COLOCATED_TEMPLATE__ from './favicon-provider.hbs'; */
import Component from '@glimmer/component';

class FaviconProvider extends Component {
  get destinationElement() {
    return document.head;
  }
}

export default FaviconProvider;
